
















import { Vue, Component } from "vue-property-decorator";
import AssignDataTable from "../../components/DataTables/AssignDataTable.vue";
import CardTitle from "../../components/CardTitle.vue";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as auth from "../../_store/auth.module";
import { bus } from "../../main";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import { InstituteInfo } from "../../_models/instituteInfo";
import * as temp from "../../_store/temp.module"

@Component({
  components: {
    AssignDataTable,
    CardTitle
  }
})
export default class AssegnazioneTutorAllievi extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private tutorDataTableParams: any;
  private settoreTutor: number;

  private listaAllievi: any;

  constructor() {
    super();
    this.settoreTutor = 0;
    this.titleParams = {
      title: "Assegnazione Allievi-Tutor Articolazione",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "5"
    };
    this.dataTableParams = {
      headers: [
        // {
        //   text: "Nome Allievo",
        //   value: "nomeUtente"
        // },
        // {
        //   text: "Cognome Allievo",
        //   value: "cognomeUtente"
        // },
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Tutor Articolazione",
          value: "tutor"
        },
        {
          text: "Classe Allievo",
          value: "classe"
        },
        {
          text: "Assegna Tutor Artic.",
          value: "tutorAllievo",
          width: "1%",
          sortable: false
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          width: "1%",
          sortable: false
        },
        {
          text: "Iscritto Attività",
          value: "iscrittoAttivita",
          width: "1%",
          sortable: false
        },
        {
          text: "Corso Sicurezza",
          value: "corsoSicurezza",
          width: "1%",
          sortable: false
        },
        {
          text: "Blocco Attività",
          value: "studentsBlocks",
          width: "1%",
          sortable: false
        },
        {
          text: "Storico Attività",
          value: "storicoAttivitaAllievo",
          width: "1%",
          sortable: false
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI UTENTE",
        type: "userTab"
      },
      filterType: "listaAllievi",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ]
    };
    this.tutorDataTableParams = {
      headers: [
        {
          text: "Cognome Tutor",
          value: "cognomeUtente"
        },
        {
          text: "Nome Tutor",
          value: "nomeUtente"
        },
        {
          text: "Assegna",
          value: "assignTutor"
        }
      ],
      records: [],
      assignmentType: "tutorAssignment",
      dialogParams: {
        title: "ELENCO TUTOR",
        type: ""
      }
    };
  }

  loadSectorStudentsList(idAnnoScolastico: number) {
    var userInfo = user.readUserInfo(this["$store"]);
    var payload = {
      idIstituto: 0,
      annoScolastico: 0,
      idSettore: 0
    };
    //var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    payload = {
      idIstituto: instituteInfo.id,
      annoScolastico: idAnnoScolastico,
      idSettore: this.settoreTutor
    };
    data
      .dispatchStudentsSettore(this["$store"], payload)
      .then(result => {
        this.listaAllievi = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        bus.$emit("stopLoading");
        this["$router"].push("/login");
      });
  }

  loadSectorTutors() {
    var payload = {
      idIstituto: 0,
      idSettore: 0
    };
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    payload = {
      idIstituto: instituteInfo.id,
      idSettore: this.settoreTutor
    }
    data
      .dispatchTutorSettore(this["$store"], payload)
      .then(response => {
        this.tutorDataTableParams.records = response;
        bus.$emit("tutorDataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var payload2 = {
      idIstituto: 0,
      idSettore: 0
    };
    // var articolazioniList: ArticolazioneInfo[];
    var instituteInfo: InstituteInfo;
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            data
              .dispatchAssegnazioneIndirizzoStudio(
                this["$store"],
                parsedToken.IdUtente
              )
              .then(res => {
                this.settoreTutor = res;
                instituteInfo = user.readInstituteInfo(this["$store"]);
                payload2 = {
                  idIstituto: instituteInfo.id,
                  idSettore: res
                };
                data
                  .dispatchArticolazioniSettore(this["$store"], payload2)
                  .then(response => {
                    response.forEach(element => {
                      this.dataTableParams.listaArticolazioni.push(element);
                    });
                    this.loadSectorStudentsList(idAnnoScolastico);
                    this.loadSectorTutors()
                  })
                  .catch(error => {
                    if (error.response.status === 403) {
                      bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                      this["$router"].push("/login");
                    } else {
                      bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                  });
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                }
              });

            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadSectorStudentsList", () => {
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
      this.loadSectorStudentsList(idAnnoScolastico);
    });

    bus.$on("filtroAllievi", (filters: any) => {
      const listaAllievi: any = this.listaAllievi;
      var tempList: any = [];
      var tempList2: any = [];
      var tempList3: any = [];
      var tempList4: any = [];
      var tempList5: any = [];
      var tempList6: any = [];
      var tempList7: any = [];
      this.dataTableParams.records = [];
      listaAllievi.forEach((allievo: any) => {
        if (filters.filtroAutorizzazione !== "Tutti") {
          if (filters.filtroAutorizzazione === "Inviati") {
            if (allievo.idStatoDoc === 1) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Eliminati") {
            if (allievo.idStatoDoc === 3) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Confermati") {
            if (allievo.idStatoDoc === 2) {
              tempList.push(allievo);
            }
          }
        } else {
          tempList.push(allievo);
        }
      });
      tempList.forEach((item: any) => {
        if (filters.filtroAnni !== "Tutti") {
          if (filters.filtroAnni === "3") {
            if (item.classe.charAt(0) === "3") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "4") {
            if (item.classe.charAt(0) === "4") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "5") {
            if (item.classe.charAt(0) === "5") {
              tempList2.push(item);
            }
          }
        } else {
          tempList2.push(item);
        }
      });
      tempList2.forEach((item: any) => {
        if (filters.fitroArticolazione !== "Tutte") {
          if (filters.fitroArticolazione === "IT01") {
            if (item.idArticolazione === "IT01") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT04") {
            if (item.idArticolazione === "IT04") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT05") {
            if (item.idArticolazione === "IT05") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT10") {
            if (item.idArticolazione === "IT10") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT13") {
            if (item.idArticolazione === "IT13") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITAF") {
            if (item.idArticolazione === "ITAF") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITEN") {
            if (item.idArticolazione === "ITEN") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITET") {
            if (item.idArticolazione === "ITET") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITIA") {
            if (item.idArticolazione === "ITIA") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITMM") {
            if (item.idArticolazione === "ITMM") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "LI03") {
            if (item.idArticolazione === "LI03") {
              tempList3.push(item);
            }
          }
        } else {
          tempList3.push(item);
        }
      });
      tempList3.forEach((item: any) => {
        if (filters.filtroSezione != "Nessuna") {
          if (filters.filtroSezione === "A") {
            if (item.classe.charAt(2) === "A") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "B") {
            if (item.classe.charAt(2) === "B") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "C") {
            if (item.classe.charAt(2) === "C") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "D") {
            if (item.classe.charAt(2) === "D") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "E") {
            if (item.classe.charAt(2) === "E") {
              tempList4.push(item);
            }
          }
          if (filters.filtroSezione === "F") {
            if (item.classe.charAt(2) === "F") {
              tempList4.push(item);
            }
          }
        } else {
          tempList4.push(item);
        }
      });
      tempList4.forEach((item: any) =>{
        if (filters.filtroBlocco !== "Tutti"){
          if(filters.filtroBlocco === "Bloccati"){
            if (item.gestioneAlternanza === false){
              tempList5.push(item);
            }
          }else if(filters.filtroBlocco === "Non Bloccati"){
            if (item.gestioneAlternanza === true){
              tempList5.push(item);
            }
          }
        }else{
          tempList5.push(item);
        }
      });
      tempList5.forEach((item: any) =>{
        if (filters.filtroAssegnazione !== "Tutti"){
          if(filters.filtroAssegnazione === "Assegnati"){
            if (item.tutor !== "") {
              tempList6.push(item);
            }
          }else if(filters.filtroAssegnazione === "Non Assegnati"){
            if (item.tutor === "") {
              tempList6.push(item);
            }
          }
        }else{
          tempList6.push(item);
        }
      });
      tempList6.forEach((item: any) =>{
        if(filters.filtroIscrizioni !== "Tutti"){
          if(filters.filtroIscrizioni === "Iscritti"){
            if(item.iscritto === true){
              tempList7.push(item);
            }
          }else if(filters.filtroIscrizioni === "Non Iscritti"){
              if(item.iscritto === false){
                tempList7.push(item);
              }
          }
        }else {
          tempList7.push(item);
        }
      });
      this.dataTableParams.records = tempList7;
    });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadSectorStudentsList(payload);
    });
  }
}
